export default {
  login: {
    title: 'Login to Seller Center',
    botton: 'Login',
    username: 'Username',
    password: 'Password'
  },
  test: {
    lang: 'English'
  },
  base: {
    excel_upload: 'Import Excel',
    excel_view_btn: 'Click to view',
    start_date: 'Start',
    end_date: 'End',
  }
}
